import React from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import LanThanhToanView from "../LanThanhToanView";
import { LaiSuatText } from "constants/choVayConst";
import choVayConst from "constants/choVayConst";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import CauHinhApi from "../../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";
import CamDoApi from "../../../service/camDoApi";
import QuanLyChoVayApi from "service/quanLyChoVayApi";
import ChoThanhToanApi from "../../../service/TichHopBank/choThanhToanApi";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import { currentDateV2 } from "utils/formatDate";

class TatToan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      objTatToan: {
        choVayId: 0,
        TenKhachHang: "",
        NgayThucHien: currentDate(),
        SoTien: 0,
        PhiKhac: 0,
        GhiChu: "",
        PhiKho: 0,
        PhiPhatThanhToanSom: 0,
        PhiPhatTatToan: 0,
        PhiPhatDongLai: 0,
        PhiPhatTatToanQuaHan: 0,
        PhiDongLaiCham: 0,
        PhiPhatTraCham: 0,
      },
      quyenTatToanChoDuyet: {
        camdo_sudungchoduyetduyettattoan: false,
        tinchap_sudungchoduyetduyettattoan: false,
        tragop_sudungchoduyetduyettattoan: false,
        nhanvay_sudungchoduyetduyettattoan: false,
      },
      HasTatToanChoDuyet: 0,
      infoTatToan1: {},
      isCauHinhT86: false,
      isDuNoGiamDan: false,
      isQRThanhToan: false,
      isWinmoney: false,
      soNgayTraCham: 0,
      soNgayTinhPhat: 0,
    };
    this.TenKhachhang = React.createRef();
    this.SoTien = React.createRef();
  }
  componentDidMount() {
    let { data, show } = this.props;
    let { choVay, objTatToan } = this.state;
    if (show) {
      let { dataSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      objTatToan.choVayId = data.ChoVayId;
      objTatToan.TenKhachHang = data.CustomerName;
      objTatToan.SoTien = data.SoTienConPhaiTra;
      objTatToan.PhiKho = data.PhiKho;
      objTatToan.PhiPhatThanhToanSom = data.PhiPhatThanhToanSom;
      objTatToan.PhiPhatTatToanQuaHan = data.PhiPhatTatToanQuaHan;
      objTatToan.PhiDongLaiCham = data.PhiDongLaiCham;
      objTatToan.NgayThucHien = currentDate();

      CauHinhApi.getTimeServer().then((response) => {
        if (response.status === 200) {
          let dateTime = new Date(convertDate(response.data.result));
          objTatToan.NgayThucHien = currentDateV2(dateTime);
        }
      });

      this.setState({
        choVay: data,
        dataSearch,
        objTatToan,
      });

      this.loadLanDongLai(dataSearch);
      this.layThongTinTatToan(objTatToan);
      this.getSuDungTatToanChoDuyet();
      this.kiemTraHopDongChoVayTatToanChoDuyet();
      CamDoApi.getConfigCamDo("SUDUNG_DUNOGIAMDAN").then((response) => {
        if (response != null) {
          this.setState({ isDuNoGiamDan: response.data.Result });
        }
      });

      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const isCauHinhT86 = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsCauHinhT86.toUpperCase()
            );
            if (isCauHinhT86 != null) {
              if (isCauHinhT86.valueConfig === "1") {
                this.setState({ isCauHinhT86: true });
              }
            }
            const configIsQRThanhToan = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsQRThanhToan.toUpperCase()
            );
            if (configIsQRThanhToan != null) {
              if (configIsQRThanhToan.valueConfig === "1") {
                this.setState({ isQRThanhToan: true });
              }
            }
            // Nhà Winmoney mới có trường "Tiền phạt trả chậm", nhà khác không
            // gọi api phí phạt để khỏi tốn thêm một lượt truy vấn.
            const configWinmoney = response.data.find(
              (e) =>
                e.keyConfig &&
                e.keyConfig.toUpperCase() ===
                  cauHinh.sKey.IsWinmoney.toUpperCase()
            );
            if (configWinmoney != null && configWinmoney.valueConfig === "1") {
              this.setState({ isWinmoney: true });
              this.loadPhiPhatTraCham(
                objTatToan.choVayId,
                objTatToan.NgayThucHien
              );
            }
          }
        }
      });
    }
    if (data === choVay && !show) this.setState({ choVay: {} });
  }
  getSuDungTatToanChoDuyet() {
    TatToanChoDuyetApi.suDungTatToanChoDuyet().then((response) => {
      let { quyenTatToanChoDuyet } = this.state;
      quyenTatToanChoDuyet.camdo_sudungchoduyetduyettattoan =
        response.data.camdo_sudungchoduyetduyettattoan;
      quyenTatToanChoDuyet.tinchap_sudungchoduyetduyettattoan =
        response.data.tinchap_sudungchoduyetduyettattoan;
      quyenTatToanChoDuyet.tragop_sudungchoduyetduyettattoan =
        response.data.tragop_sudungchoduyetduyettattoan;
      quyenTatToanChoDuyet.nhanvay_sudungchoduyetduyettattoan =
        response.data.nhanvay_sudungchoduyetduyettattoan;
      this.setState({ quyenTatToanChoDuyet });
    });
  }
  kiemTraHopDongChoVayTatToanChoDuyet() {
    let { data } = this.props;
    let { HasTatToanChoDuyet } = this.state;
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(data.ChoVayId).then(
      (response) => {
        if (
          response.data != null &&
          response.data != undefined &&
          response.data.TatToanChoDuyet
        ) {
          HasTatToanChoDuyet = response.data.TatToanChoDuyet;
          this.setState({ HasTatToanChoDuyet });
        }
      }
    );
  }
  static getDerivedStateFromProps(props, state) {
    let { quanlychovay } = props;
    let { objTatToan, infoTatToan1 } = state;
    let { infoTatToan } = quanlychovay;
    if (infoTatToan1 !== infoTatToan) {
      objTatToan.SoTien =
        infoTatToan.SoTienConPhaiTra + infoTatToan.PhiHangKyPhaiTra;
      objTatToan.PhiKho = infoTatToan.PhiKho;
      objTatToan.PhiKhac = infoTatToan.PhiPhatThanhToanSom;
      objTatToan.PhiPhatTatToanQuaHan = infoTatToan.PhiPhatTatToanQuaHan;
      objTatToan.PhiPhatDongLai = infoTatToan.PhiPhatDongLai;
      objTatToan.PhiPhatTatToan = infoTatToan.PhiPhatTatToan;
      objTatToan.PhiDongLaiCham = infoTatToan.PhiDongLaiCham;
      return { objTatToan: objTatToan, infoTatToan1: infoTatToan };
    } else return state;
    // if (!errorTatToan && !tatToanChoVayLoading && show) {
    //   onHide();
    // }
  }
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }
  layThongTinTatToan(objTatToan) {
    let { getTatToanChoVay } = this.props;
    getTatToanChoVay({
      choVayId: objTatToan.choVayId,
      ngaythanhtoan: objTatToan.NgayThucHien,
    });
  }

  onChangeData = (field) => (event) => {
    let { objTatToan } = this.state;
    objTatToan[field] = event.target.value;
    this.setState({ objTatToan });
  };
  handlePageChange = () => (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };
  tatToan = () => () => {
    let { dataSearch, objTatToan } = this.state;
    let { postTatToanChoVay } = this.props;
    if (!objTatToan.TenKhachHang) {
      pushNotification("Nhập tên người trả.", "warning", "TOP_CENTER", 1000);
      this.TenKhachhang.current.focus();
      return;
    }
    if (!objTatToan.SoTien && objTatToan.SoTien != 0) {
      pushNotification("Nhập tiền trả gốc", "warning", "TOP_CENTER", 1000);
      this.SoTien.current.focus();
      return;
    }

    postTatToanChoVay(
      {
        ...objTatToan,
        // Trên form phải để riêng hai ô vì getDerivedStateFromProps ghi đè
        // PhiDongLaiCham, nhưng khi gửi thì gộp làm một vì cùng vào một cột ThuChi.
        PhiDongLaiCham:
          Number(objTatToan.PhiDongLaiCham || 0) +
          Number(objTatToan.PhiPhatTraCham || 0),
      },
      dataSearch
    );
    objTatToan.SoTien = 0;
    objTatToan.PhiKhac = 0;
    objTatToan.PhiKho = 0;
    objTatToan.PhiPhatThanhToanSom = 0;
    objTatToan.PhiPhatTatToanQuaHan = 0;
    objTatToan.PhiDongLaiCham = 0;
    objTatToan.GhiChu = "";
    objTatToan.PhiPhatTatToan = 0;
    objTatToan.PhiPhatDongLai = 0;
    objTatToan.PhiPhatTraCham = 0;
    // Ô phạt đã về 0 thì nhãn số ngày cũng phải mất theo
    this.setState({ objTatToan, soNgayTraCham: 0, soNgayTinhPhat: 0 });
  };
  tatToanChoDuyet = () => () => {
    let { dataSearch, objTatToan, HasTatToanChoDuyet } = this.state;
    let { postTatToanChoDuyetChoVay } = this.props;
    if (!objTatToan.TenKhachHang) {
      pushNotification("Nhập tên người trả.", "warning", "TOP_CENTER", 1000);
      this.TenKhachhang.current.focus();
      return;
    }
    if (!objTatToan.SoTien) {
      pushNotification("Nhập tiền trả gốc", "warning", "TOP_CENTER", 1000);
      this.SoTien.current.focus();
      return;
    }

    postTatToanChoDuyetChoVay(
      {
        ...objTatToan,
      },
      dataSearch
    );
    this.state.HasTatToanChoDuyet = 1;
  };
  thanhToanCho = () => () => {
    let { dataSearch, objTatToan } = this.state;
    let { postTatToanChoVay } = this.props;
    if (!objTatToan.TenKhachHang) {
      pushNotification("Nhập tên người trả.", "warning", "TOP_CENTER", 1000);
      this.TenKhachhang.current.focus();
      return;
    }
    if (!objTatToan.SoTien && objTatToan.SoTien != 0) {
      pushNotification("Nhập tiền trả gốc", "warning", "TOP_CENTER", 1000);
      this.SoTien.current.focus();
      return;
    }
    objTatToan.NgayTatToan = objTatToan.NgayThucHien;

    objTatToan.TienTatToan = objTatToan.SoTien;
    ChoThanhToanApi.saveChoThanhToanTatToan(objTatToan).then((response) => {
      if (response.status === 200) {
        pushNotification(
          "Tạo chờ thanh toán thành công.",
          "success",
          "TOP_RIGHT",
          2000
        );
      } else {
        pushNotification("Có lỗi xảy ra.", "error", "TOP_CENTER", 1000);
      }
    });

    objTatToan.SoTien = 0;
    objTatToan.PhiKhac = 0;
    objTatToan.PhiKho = 0;
    objTatToan.PhiPhatThanhToanSom = 0;
    objTatToan.PhiPhatTatToanQuaHan = 0;
    objTatToan.PhiDongLaiCham = 0;
    objTatToan.GhiChu = "";
    objTatToan.PhiPhatTatToan = 0;
    objTatToan.PhiPhatDongLai = 0;
    objTatToan.PhiPhatTraCham = 0;
    // Ô phạt đã về 0 thì nhãn số ngày cũng phải mất theo
    this.setState({ objTatToan, soNgayTraCham: 0, soNgayTinhPhat: 0 });
  };
  onChangeDate = (field) => (evt) => {
    let { objTatToan } = this.state;
    objTatToan[field] = formatDayMonth(evt);
    this.setState({ objTatToan });
    this.layThongTinTatToan(objTatToan);
    if (this.state.isWinmoney)
      this.loadPhiPhatTraCham(objTatToan.choVayId, objTatToan.NgayThucHien);
  };
  // Tiền phạt trả chậm = số ngày tính phí * gốc còn lại * đơn giá cấu hình phiPhatTraCham.
  // Giữ ở field riêng PhiPhatTraCham chứ không dùng chung PhiDongLaiCham: getDerivedStateFromProps
  // ghi đè PhiDongLaiCham mỗi lần api tất toán trả về, dùng chung sẽ bị mất số.
  // Số tiền chỉ điền sẵn, nhân viên vẫn sửa tay được trước khi thu.
  loadPhiPhatTraCham = (choVayId, toDate) => {
    QuanLyChoVayApi.phiPhatTraCham({ choVayId, toDate }).then((response) => {
      if (response.status === 200) {
        let { objTatToan } = this.state;
        objTatToan.PhiPhatTraCham = response.data.TienPhatTraCham ?? 0;
        this.setState({
          objTatToan,
          soNgayTraCham: response.data.SoNgay ?? 0,
          soNgayTinhPhat: response.data.SoNgayTinhPhat ?? 0,
        });
      }
    });
  };
  onChangeData = (field) => (event) => {
    let { objTatToan } = this.state;
    objTatToan[field] = event.target.value;
    this.setState({ objTatToan });
  };
  onChangeNumber = (field) => (evt) => {
    let { objTatToan } = this.state;
    objTatToan[field] = convertToNumber(evt.target.value);
    this.setState({ objTatToan });
  };
  render() {
    let props = this.props;
    let {
      data,
      quanlychovay,
      buttonLeft,
      onHide,
      chonngaygiaodich,
      isShowPhiKho,
      quyenSuaTienTatToan,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungPhiPhat_DongLai_Cham,
      SuDungTatToanSom,
    } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
    } = quanlychovay.objListDonglai;
    let { getLanDongLaiChoVayLoading, tatToanChoVayLoading, infoTatToan } =
      quanlychovay;
    let {
      TongTienPhaiTra,
      SoTienDaTra,
      SoTienConPhaiTra,
      SoNgayTraLai,
      PhiHangKyPhaiTra,
    } = infoTatToan;
    let {
      dataSearch,
      objTatToan,
      isCauHinhT86,
      isDuNoGiamDan,
      isQRThanhToan,
      isWinmoney,
      soNgayTraCham,
      soNgayTinhPhat,
    } = this.state;
    let {
      TenKhachHang,
      NgayThucHien,
      SoTien,
      PhiKhac,
      PhiKho,
      GhiChu,
      PhiPhatTatToan,
      PhiPhatDongLai,
      PhiPhatTatToanQuaHan,
      PhiDongLaiCham,
      PhiPhatTraCham,
    } = objTatToan;
    console.log(objTatToan, "objTatToanobjTatToanobjTatToanobjTatToan");
    if (NgayThucHien) NgayThucHien = convertDate(NgayThucHien);
    let { Type, StatusPaidHo } = data;

    console.log(isShowPhiKho);
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-from-tat-toan-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              {" "}
              Tất toán{" "}
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " +
              (getLanDongLaiChoVayLoading || tatToanChoVayLoading
                ? "is-active"
                : "")
            }
          ></div>
          {this.state.HasTatToanChoDuyet === 1 && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="thongbaotattoan">
                    <i class="mdi mdi-alert" style={{ color: "#d39c00" }}></i>{" "}
                    HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row">
            <div className="col-md-12 col-lg-3  pad-right0">
              <div class="donglai-form">
                {/* <ul className="nav nav-tabs bg-tab">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="base-tab1"
                      data-toggle="tab"
                      aria-controls="tab1"
                      href="#tab-noidungtra"
                      aria-expanded="true"
                    >
                      <h4>Nội dung tất toán</h4>
                    </a>
                  </li>
                </ul>  */}
                <h4>
                  <span style={{ fontWeight: "bold !important;" }}>
                    {" "}
                    <img src="/app-assets/images/icon-tat-toan-trang.png" />
                    &nbsp;&nbsp; Nội dung tất toán
                  </span>
                </h4>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-noidungtra"
                    aria-labelledby="base-tab1"
                  >
                    <div className="detail-tattoan">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Người thanh toán</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={TenKhachHang}
                              ref={this.TenKhachhang}
                              onChange={this.onChangeData("TenKhachHang")}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ngày thanh toán</label>
                            <DateTimePicker
                              value={NgayThucHien}
                              onChange={this.onChangeDate("NgayThucHien")}
                              readOnly={!chonngaygiaodich}
                            ></DateTimePicker>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Tiền tất toán</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={formatNumber(SoTien)}
                              ref={this.SoTien}
                              onChange={this.onChangeNumber("SoTien")}
                              readOnly={!quyenSuaTienTatToan}
                            />
                          </div>
                        </div>
                        {data.Type === 3 && isShowPhiKho == 1 && (
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Phí kho</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(PhiKho)}
                                onChange={this.onChangeNumber("PhiKho")}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Phí khác</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={formatNumber(PhiKhac)}
                              onChange={this.onChangeNumber("PhiKhac")}
                            />
                          </div>
                        </div>
                        {isWinmoney && (
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Tiền phạt trả chậm
                                {soNgayTraCham > 0 && (
                                  <span className="red">
                                    {" "}
                                    {soNgayTraCham > soNgayTinhPhat
                                      ? "(trễ " +
                                        soNgayTraCham +
                                        " ngày, tính " +
                                        soNgayTinhPhat +
                                        " ngày)"
                                      : "(" + soNgayTraCham + " ngày)"}
                                  </span>
                                )}
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(PhiPhatTraCham)}
                                onChange={this.onChangeNumber("PhiPhatTraCham")}
                              />
                            </div>
                          </div>
                        )}
                        {/* {isCauHinhT86.valueConfig === "1" &&( */}
                        {isDuNoGiamDan == true && (
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Phạt tất toán quá hạn</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(PhiPhatTatToanQuaHan)}
                                onChange={this.onChangeNumber(
                                  "PhiPhatTatToanQuaHan"
                                )}
                              />
                            </div>
                          </div>
                        )}
                        {SuDungPhiPhat_DongLai_Cham && (
                          <div className="col-md-12">
                            <div class="form-group">
                              <label class="text-label">Phí phạt</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(PhiDongLaiCham)}
                                onChange={this.onChangeNumber("PhiDongLaiCham")}
                              />
                            </div>
                          </div>
                        )}
                        {SuDungPhiPhat_DongLai_TatToan && (
                          <>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>Phạt chậm đóng lãi</label>
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  value={formatNumber(PhiPhatDongLai)}
                                  onChange={this.onChangeNumber(
                                    "PhiPhatDongLai"
                                  )}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {SuDungTatToanSom && (
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Phạt tất toán sớm</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(PhiPhatTatToan)}
                                onChange={this.onChangeNumber("PhiPhatTatToan")}
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Tổng tiền thu</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={formatNumber(
                                SoTien +
                                  PhiKhac +
                                  PhiKho +
                                  PhiPhatDongLai +
                                  PhiPhatTatToan +
                                  PhiPhatTatToanQuaHan +
                                  PhiDongLaiCham +
                                  (isWinmoney ? PhiPhatTraCham : 0)
                              )}
                              ref={this.SoTien}
                              onChange={this.onChangeNumber("SoTien")}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Ghi chú</label>
                            <textarea
                              rows="3"
                              className="form-control input-sm"
                              placeholder="Ghi chú"
                              value={GhiChu}
                              onChange={this.onChangeData("GhiChu")}
                            ></textarea>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet === 0 && (
                              <>
                                {isQRThanhToan && (
                                  <button
                                    type="button"
                                    class="btn btn-new-main btn-checknew"
                                    onClick={this.thanhToanCho()}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <span class="btn-icon-left">
                                      <i class="mdi mdi-check-underline-circle"></i>
                                    </span>
                                    Thanh toán chờ
                                  </button>
                                )}

                                {data.Type === 3 &&
                                this.state.quyenTatToanChoDuyet
                                  .camdo_sudungchoduyetduyettattoan === true ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-new-main btn-checknew"
                                      onClick={this.tatToanChoDuyet()}
                                    >
                                      <span className="btn-icon-left">
                                        <i className="mdi mdi-check-underline-circle"></i>
                                      </span>{" "}
                                      Gửi duyệt
                                    </button>
                                  </>
                                ) : data.Type === 1 &&
                                  this.state.quyenTatToanChoDuyet
                                    .tinchap_sudungchoduyetduyettattoan ===
                                    true ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-new-main btn-checknew"
                                      onClick={this.tatToanChoDuyet()}
                                    >
                                      <span className="btn-icon-left">
                                        <i className="mdi mdi-check-underline-circle"></i>
                                      </span>{" "}
                                      Gửi duyệt
                                    </button>
                                  </>
                                ) : data.Type === 2 &&
                                  this.state.quyenTatToanChoDuyet
                                    .tragop_sudungchoduyetduyettattoan ===
                                    true ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-new-main btn-checknew"
                                      onClick={this.tatToanChoDuyet()}
                                    >
                                      <span className="btn-icon-left">
                                        <i className="mdi mdi-check-underline-circle"></i>
                                      </span>{" "}
                                      Gửi duyệt
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-new-main btn-checknew"
                                      onClick={this.tatToan()}
                                    >
                                      <span className="btn-icon-left">
                                        <i className="mdi mdi-check-underline-circle"></i>
                                      </span>{" "}
                                      Xác nhận
                                    </button>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-9">
              <div className="tattoan-formright">
                {isCauHinhT86 == false && (
                  <>
                    <ul className="nav nav-tabs bg-tab tab-vaythem">
                      <li className="nav-item active">
                        <a
                          className="nav-link active"
                          id="base-tab12"
                          data-toggle="tab"
                          aria-controls="tab12"
                          href="#tbg-thongtinhd"
                          aria-expanded="true"
                        >
                          <h4 className="color7-bold">Thông tin hợp đồng</h4>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link "
                          id="base-tab13"
                          data-toggle="tab"
                          aria-controls="tab13"
                          href="#detailtbg"
                          aria-expanded="true"
                        >
                          <h4 className="color7-bold">Chi tiết đóng lãi</h4>
                        </a>
                      </li>
                    </ul>
                  </>
                )}
                {isCauHinhT86 == true && (
                  <>
                    <ul className="nav nav-tabs bg-tab">
                      <li className="nav-item active">
                        <a
                          className="nav-link active"
                          id="base-tab13"
                          data-toggle="tab"
                          aria-controls="tab13"
                          href="#detailtbg"
                          aria-expanded="true"
                        >
                          <h4>Chi tiết đóng lãi</h4>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link "
                          id="base-tab12"
                          data-toggle="tab"
                          aria-controls="tab12"
                          href="#tbg-thongtinhd"
                          aria-expanded="true"
                        >
                          <h4>Thông tin hợp đồng</h4>
                        </a>
                      </li>
                    </ul>
                  </>
                )}
                <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                  {isCauHinhT86 == true && (
                    <>
                      <div
                        role="tabpanel"
                        className="tab-pane "
                        id="tbg-thongtinhd"
                        aria-labelledby="base-tab1"
                      >
                        <div class="from-ndtra" style={{ marginTop: "10px" }}>
                          <div class="from-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Tất toán hợp đồng:{" "}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-xanh-bold">
                                    {data.Code}
                                  </span>
                                </div>
                              </div>
                            </p>
                            <p></p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền vay:{" "}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {formatNumber(
                                      data.SoTienVayConLai
                                        ? data.SoTienVayConLai
                                        : data.Sotienvay
                                    )}{" "}
                                    &nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            {data.Type !== 2 && (
                              <p>
                                <div className="row">
                                  <div className="col-label-thong-tin-hd color7-bold">
                                    Lãi suất:{" "}
                                  </div>
                                  <div className="col-3 text-left  text-normal color7">
                                    <span className="color-vang-bold">
                                      {data.StatusPaidHo !== 3 && (
                                        <>
                                          {
                                            choVayConst.KieuLaiSuatText[
                                              data.KieuLaiSuat
                                            ]
                                          }
                                          :{" "}
                                          {LaiSuatText(data, data.KieuLaiSuat)}
                                        </>
                                      )}
                                      {data.StatusPaidHo === 3 &&
                                        data.ChiPhiVay.toFixed(2) + "%"}
                                    </span>
                                  </div>
                                </div>
                              </p>
                            )}
                            {data.Type === 2 && (
                              <p>
                                <div className="row">
                                  <div className="col-label-thong-tin-hd color7-bold">
                                    Lãi suất:
                                  </div>
                                  <div className="col-3 text-left  text-normal color7">
                                    <span className="color-vang-bold">
                                      {data.StatusPaidHo === 1 &&
                                        formatNumber(
                                          Math.ceil(
                                            data.ValueLai * data.CountTypePaid
                                          )
                                        ) + "đ"}
                                      {data.StatusPaidHo === 2 &&
                                        formatNumber(
                                          Math.ceil(
                                            data.ValueLai * data.BocTrongVong
                                          )
                                        ) + "đ"}
                                      {data.StatusPaidHo === 3 &&
                                        data.ChiPhiVay.toFixed(2) + "%"}
                                    </span>
                                  </div>
                                </div>
                              </p>
                            )}
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Kiểu vay:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span>{choVayConst.TypeText[data.Type]}</span>
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Thời gian vay:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span>
                                    {" "}
                                    {getDate(data.NgayVay)}-
                                    {getDate(data.NgayTra)}
                                  </span>
                                </div>
                              </div>
                            </p>
                          </div>
                          <div class="from-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Tổng tiền phải trả:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {" "}
                                    {formatNumber(TongTienPhaiTra)}&nbsp;{" "}
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền đã trả :
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-xanh-bold">
                                    {" "}
                                    {formatNumber(SoTienDaTra)}&nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền còn phải trả:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {formatNumber(SoTienConPhaiTra)}&nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  {SoNgayTraLai}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span></span>
                                </div>
                              </div>
                            </p>
                          </div>
                          <div class="note-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Ghi chú:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span> {data.Note}</span>
                                </div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        role="tabpanel"
                        className="tab-pane active"
                        id="detailtbg"
                        aria-labelledby="base-tab1"
                      >
                        <LanThanhToanView
                          List={List}
                          TongCanThanhToan={TongCanThanhToan}
                          TongPhiKhac={TongPhiKhac}
                          TongPhiKho={TongPhiKho}
                          TongThanhToan={TongThanhToan}
                          TongTienGoc={TongTienGoc}
                          TongTienLai={TongTienLai}
                          totalRow={totalRow}
                          TongPhiKhacHangKy={TongPhiKhacHangKy}
                          handlePageChange={this.handlePageChange()}
                          pageIndex={dataSearch.pageIndex}
                          pageSize={dataSearch.pageSize}
                          Type={Type}
                          StatusPaidHo={StatusPaidHo}
                        ></LanThanhToanView>
                      </div>
                    </>
                  )}
                  {isCauHinhT86 == false && (
                    <>
                      <div
                        role="tabpanel"
                        className="tab-pane active"
                        id="tbg-thongtinhd"
                        aria-labelledby="base-tab1"
                      >
                        <div class="from-ndtra">
                          <div class="from-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Tất toán hợp đồng:{" "}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-xanh-bold">
                                    {data.Code}
                                  </span>
                                </div>
                              </div>
                            </p>
                            <p></p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền vay:{" "}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {formatNumber(
                                      data.SoTienVayConLai
                                        ? data.SoTienVayConLai
                                        : data.Sotienvay
                                    )}{" "}
                                    &nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            {data.Type !== 2 && (
                              <p>
                                <div className="row">
                                  <div className="col-label-thong-tin-hd color7-bold">
                                    Lãi suất:{" "}
                                  </div>
                                  <div className="col-3 text-left  text-normal color7">
                                    <span className="color-vang-bold">
                                      {data.StatusPaidHo !== 3 && (
                                        <>
                                          {
                                            choVayConst.KieuLaiSuatText[
                                              data.KieuLaiSuat
                                            ]
                                          }
                                          :{" "}
                                          {LaiSuatText(data, data.KieuLaiSuat)}
                                        </>
                                      )}
                                      {data.StatusPaidHo === 3 &&
                                        data.ChiPhiVay.toFixed(2) + "%"}
                                    </span>
                                  </div>
                                </div>
                              </p>
                            )}
                            {data.Type === 2 && (
                              <p>
                                <div className="row">
                                  <div className="col-label-thong-tin-hd color7-bold">
                                    Lãi suất:
                                  </div>
                                  <div className="col-3 text-left  text-normal color7">
                                    <span className="color-vang-bold">
                                      {data.StatusPaidHo === 1 &&
                                        formatNumber(
                                          Math.ceil(
                                            data.ValueLai * data.CountTypePaid
                                          )
                                        ) + "đ"}
                                      {data.StatusPaidHo === 2 &&
                                        formatNumber(
                                          Math.ceil(
                                            data.ValueLai * data.BocTrongVong
                                          )
                                        ) + "đ"}
                                      {data.StatusPaidHo === 3 &&
                                        data.ChiPhiVay.toFixed(2) + "%"}
                                    </span>
                                  </div>
                                </div>
                              </p>
                            )}
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Kiểu vay:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span>{choVayConst.TypeText[data.Type]}</span>
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Thời gian vay:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span>
                                    {" "}
                                    {getDate(data.NgayVay)}-
                                    {getDate(data.NgayTra)}
                                  </span>
                                </div>
                              </div>
                            </p>
                          </div>
                          <div class="from-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Tổng tiền phải trả:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {" "}
                                    {formatNumber(
                                      TongTienPhaiTra + PhiHangKyPhaiTra
                                    )}
                                    &nbsp;{" "}
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền đã trả :
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-xanh-bold">
                                    {" "}
                                    {formatNumber(SoTienDaTra)}&nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Số tiền còn phải trả:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span className="color-do-bold">
                                    {formatNumber(
                                      SoTienConPhaiTra + PhiHangKyPhaiTra
                                    )}
                                    &nbsp;
                                  </span>
                                  (vnđ)
                                </div>
                              </div>
                            </p>
                            {/* <p>
                            Phí hàng kỳ còn phải trả:{" "}
                            <span class="red">
                              {formatNumber(PhiHangKyPhaiTra)}
                            </span>{" "}
                            (vnđ)
                          </p> */}
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  {SoNgayTraLai}
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span></span>
                                </div>
                              </div>
                            </p>
                          </div>
                          <div class="note-thongtintra">
                            <p>
                              <div className="row">
                                <div className="col-label-thong-tin-hd color7-bold">
                                  Ghi chú:
                                </div>
                                <div className="col-3 text-left  text-normal color7">
                                  <span> {data.Note}</span>
                                </div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        role="tabpanel"
                        className="tab-pane"
                        id="detailtbg"
                        aria-labelledby="base-tab1"
                      >
                        <LanThanhToanView
                          List={List}
                          TongCanThanhToan={TongCanThanhToan}
                          TongPhiKhac={TongPhiKhac}
                          TongPhiKho={TongPhiKho}
                          TongThanhToan={TongThanhToan}
                          TongTienGoc={TongTienGoc}
                          TongTienLai={TongTienLai}
                          totalRow={totalRow}
                          TongPhiKhacHangKy={TongPhiKhacHangKy}
                          handlePageChange={this.handlePageChange()}
                          pageIndex={dataSearch.pageIndex}
                          pageSize={dataSearch.pageSize}
                          Type={Type}
                          StatusPaidHo={StatusPaidHo}
                        ></LanThanhToanView>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={onHide}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng&nbsp;
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default TatToan;
